import { render, staticRenderFns } from "./news_poll_replies.vue?vue&type=template&id=2515599a&"
import script from "./news_poll_replies.vue?vue&type=script&lang=js&"
export * from "./news_poll_replies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports